import { Badge } from "@/components/ui/Badge";
import { cn } from "@/lib/utils";

type StatusVariant =
  | "default"
  | "secondary"
  | "success"
  | "warning"
  | "destructive"
  | "outline";

/** Shared status -> variant mapping across cases, farms, officers, and orders. */
const STATUS_VARIANT_MAP: Record<string, StatusVariant> = {
  OPEN: "destructive",
  IN_PROGRESS: "warning",
  RESOLVED: "default",
  CLOSED: "success",
  ACTIVE: "success",
  INACTIVE: "destructive",
  PENDING: "warning",
  APPROVED: "success",
  ACCEPTED: "default",
  FULFILLED: "success",
  CONFIRMED: "default",
  COMPLETED: "success",
  CANCELLED: "destructive",
  DRAFT: "secondary",
};

interface StatusBadgeProps {
  status: string;
  variant?: StatusVariant;
  className?: string;
}

export function StatusBadge({ status, variant, className }: StatusBadgeProps) {
  const resolved = variant ?? STATUS_VARIANT_MAP[status.toUpperCase()] ?? "outline";
  return (
    <Badge variant={resolved} className={cn("text-xs", className)}>
      {status.replace(/_/g, " ")}
    </Badge>
  );
}
